module.exports = __webpack_public_path__ + "static/media/26.79e680f2.png";